import { render, staticRenderFns } from "./ProposalSlider.vue?vue&type=template&id=29f21756"
import script from "./ProposalSlider.vue?vue&type=script&lang=js"
export * from "./ProposalSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports